import React, { useEffect } from 'react';
import Topnavigation from '../../../../layouts/Topnavigation';
import Sidenavigation1 from '../../../../layouts/Sidenavigation1';

import Content from './Content';
import { TheMasterContextProvider } from '../../../../MyContexts/Master_Context';
import OrderFunctions from '../../../../../MyFunctions/OrderFunctions';
import Translator from '../../../../../MyFunctions/Translator';

const InvoiceMobiTable = (props) => {

    useEffect(() => {
    }, [])

    //מציג את כל הנלווים של המוצר
    const getSpecials = (ordIttem, ordItmIndx) => {
        let specCount = 0;
        let price = 0;
        let vals;
        let specc =
            ordIttem.prodOptions?.map((optionGroup, index) => {
                specCount++;
                const selectedOptions = optionGroup.options.filter((opt) => opt.selected); // Get selected options                                                          
                return selectedOptions.length > 0 ? (
                    <div key={index}>
                        <span className={"fullRow smallFont"}>{optionGroup.optionName}:</span>
                        <div>
                            {selectedOptions.map((selectedOpt, optIndex) => {
                                price += selectedOpt.addToPrice * selectedOpt.mount;
                                return (
                                    <div key={optIndex}>
                                        <div className={"fullRow regular"}>
                                            <span className={"bold"}>{selectedOpt.servType}</span>
                                            <div className={"onRight"}> {selectedOpt.mount > 1 ? ` כמות: ${(selectedOpt.mount)}` : ""}</div>
                                            <div className={"onLeft"}>{selectedOpt.addToPrice > 0 ? `+₪${(selectedOpt.addToPrice * selectedOpt.mount)}` : ""}</div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                ) : null;
            })
        if (specCount > 0) {
            vals =
                <div key={ordItmIndx} className={"ordItmSpecLine"}>
                    <div className={"ordItmOptHead overflowHid bold"} >{ordIttem.optionName}</div>
                    {specc}
                </div>
        }
        return (
            { vals, price }
        )

    }


    return (
        <div className="col-md-12 overflowHid ordertblBody">

            {/* Invoice Table */}
            <div className="ms-invoice-table table-responsive">
                <div className="table table-hover text-right thead-light">

                    <div>
                        {props.theOrder?.orderItems.map((item, i) => {
                            let Specialss = getSpecials(item, i);
                            return Array.from({ length: item.mount }).map((_, jump) => (
                                <div key={`${i}-${jump}`} className="invoiceMobiTblBlock">
                                    <div className={"fullRow"}>
                                        <div className="textRight onRight">{props.arabic ? Translator.getInArab("כמות") : "כמות"}</div>
                                        <div className="textRight onRight bold spaceMargeRightbig">{1}</div>

                                        <div className="textRight onLeft bold ">₪{parseFloat(item.basePrice)}</div>
                                        <div className="textRight onLeft spaceMargeLeftbig">{props.arabic ? Translator.getInArab("ליח'") : "ליח'"}</div>
                                    </div>
                                    <div className="textRight bold">{item.prodName}
                                        <br />
                                        <div className="textRight onlyOnPrint">{item.mount}</div>
                                    </div>
                                    <div className="textRight">{(item.Remarks) ?
                                        <>
                                            <div>{Specialss.vals}</div>
                                            <br />
                                            <div className="textRight bold" >{props.arabic ? Translator.getInArab("הערה") : "הערה"}: {item.Remarks}</div>
                                        </>
                                        : Specialss.vals}</div>

                                    <div className={"fullRow textLeft"}>
                                        <div className="textLeft onLeft bold">₪{(parseFloat(item.basePrice) + parseFloat(Specialss.price))}</div>
                                        <div className="textLeft onLeft spaceMargeLeftbig">{props.arabic ? Translator.getInArab(`סה"כ`) : `סה"כ`}</div>

                                    </div>

                                    <div className={"dottedLine spaceButtomBig"}></div>

                                </div>

                            ))
                        })}
                        {(props.theOrder?.OrderType !== "Take") ?
                            <div className="invoiceMobiTblBlock">
                                <div className={"fullRow"}>
                                    <div className="textRight onRight">{props.arabic ? Translator.getInArab("משלוח") : `משלוח (${props.theOrder.deliveryAddress?.city})`}</div>
                                    <div className="textRight onRight bold spaceMargeRightbig"></div>

                                    <div className="textLeft onLeft  bold">₪{props.theOrder?.deliveryPrice}</div>
                                    {/* <div className="textLeft onLeft spaceMargeRightbig">{props.arabic ? Translator.getInArab(`סה"כ`) : `סה"כ`}</div> */}
                                </div>
                                <div className={"dottedLine spaceButtomBig"}></div>

                            </div>

                            : ""}

                    </div>
                    <br />
                    <br />
                    <div className={"fullRow"}>
                        <div className="bold veryBig textLeft onLeft">{(props.theOrder != null) ? `₪${props.theOrder.totalPrice}` : ""} </div>
                        <div colSpan={4} className="bold veryBig textLeft onLeft spaceMargeLeftbig">{props.arabic ? Translator.getInArab(`סה"כ`) : `סה"כ`}: </div>

                    </div>
                    <div className={"fullRow"}>
                        <div className="bold veryBig textLeft onLeft ">
                            {props.arabic ? Translator.getInArab(OrderFunctions.payingTYpe(props.theOrder)) : OrderFunctions.payingTYpe(props.theOrder)} </div>
                        <div colSpan={4} className="bold textLeft veryBig onLeft spaceMargeLeftbig">
                            {props.arabic ? Translator.getInArab("אופן תשלום") : "אופן תשלום"}:</div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default InvoiceMobiTable;